import { mapGetters, mapActions, mapMutations } from 'vuex'
import { GETTERS, ACTIONS, MUTATIONS } from '@/store'
import { toggleFocus } from '@/utils/toggleFocus'

/**
 *  Feedback script file
**/

export default {
  name: 'app-feedback',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      value: 0,
      sent: false,
      hovering: 0,
      language: this.$i18n.locale
    }
  },
  computed: {
    ...mapGetters({
      feedback: GETTERS.GET_FEEDBACK,
      airportID: GETTERS.GET_AIRPORT_ID,
      pmr: GETTERS.GET_PMR_PROFILE
    }),
    feedbacks () {
      return [
        {
          value: 1,
          text: this.$t('FEEDBACK_VERY_LITTLE')
        },
        {
          value: 2,
          text: this.$t('FEEDBACK_LITTLE')
        },
        {
          value: 3,
          text: this.$t('FEEDBACK_NORMAL')
        },
        {
          value: 4,
          text: this.$t('FEEDBACK_QUITE')
        },
        {
          value: 5,
          text: this.$t('FEEDBACK_VERY_QUITE')
        }
      ]
    },
    text () {
      return this.value && this.feedbacks.find(x => x.value === this.value).text
    }
  },
  mounted () {
    const parent = document.querySelector('.flughaveno-map')
    window.setTimeout(() => {
      const dialog = this.$refs.feedback
      toggleFocus('feedback-wrapper', parent, true)
      dialog.focus()
    }, 300)
  },
  beforeDestroy () {
    this.removeFeedbackFocus()
    document.removeEventListener('keydown', this.onCloseNoFeedback)
  },
  methods: {
    ...mapActions([
      ACTIONS.SET_FEEDBACK
    ]),
    ...mapMutations([
      MUTATIONS.SAVE_FEEDBACK
    ]),
    onClose () {
      this.removeFeedbackFocus()
      this[MUTATIONS.SAVE_FEEDBACK]()
    },
    onCloseNoFeedback () {
      if (!this.sent) {
        this.sentFeedback('encuesta descartada', 'no enviada')
      }
      this.onClose()
    },
    onFeedback (value) {
      this.value = value
    },
    onSubmit () {
      this[ACTIONS.SET_FEEDBACK]({ answered: true })
      this.sent = true
      this.sentFeedback(this.value)
    },
    sentFeedback (value, action = 'enviada') {
      const data = {
        'eventCategory': 'encuesta',
        'eventAction': action,
        'eventLabel': value,
        'language': this.$i18n.locale,
        'airportID': this.airportID
      }
      window.digitalChange('event', data)
    },
    removeFeedbackFocus () {
      const parent = document.querySelector('.flughaveno-map')
      toggleFocus('feedback-wrapper', parent, false)
    }
  }
}
